const HamburgerMenuIcon = () => (
	<svg
		fill='none'
		height='14'
		viewBox='0 0 22 14'
		width='22'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			clip-rule='evenodd'
			d='M0.25 1C0.25 0.801088 0.329018 0.610322 0.46967 0.46967C0.610322 0.329018 0.801088 0.25 1 0.25H21C21.1989 0.25 21.3897 0.329018 21.5303 0.46967C21.671 0.610322 21.75 0.801088 21.75 1C21.75 1.19891 21.671 1.38968 21.5303 1.53033C21.3897 1.67098 21.1989 1.75 21 1.75H1C0.801088 1.75 0.610322 1.67098 0.46967 1.53033C0.329018 1.38968 0.25 1.19891 0.25 1ZM0.25 7C0.25 6.80109 0.329018 6.61032 0.46967 6.46967C0.610322 6.32902 0.801088 6.25 1 6.25H21C21.1989 6.25 21.3897 6.32902 21.5303 6.46967C21.671 6.61032 21.75 6.80109 21.75 7C21.75 7.19891 21.671 7.38968 21.5303 7.53033C21.3897 7.67098 21.1989 7.75 21 7.75H1C0.801088 7.75 0.610322 7.67098 0.46967 7.53033C0.329018 7.38968 0.25 7.19891 0.25 7ZM0.25 13C0.25 12.8011 0.329018 12.6103 0.46967 12.4697C0.610322 12.329 0.801088 12.25 1 12.25H21C21.1989 12.25 21.3897 12.329 21.5303 12.4697C21.671 12.6103 21.75 12.8011 21.75 13C21.75 13.1989 21.671 13.3897 21.5303 13.5303C21.3897 13.671 21.1989 13.75 21 13.75H1C0.801088 13.75 0.610322 13.671 0.46967 13.5303C0.329018 13.3897 0.25 13.1989 0.25 13Z'
			fill='currentColor'
			fill-rule='evenodd'
		/>
	</svg>
)

export { HamburgerMenuIcon }
